import { render } from "./PersonalTimetablePage.vue?vue&type=template&id=11bb2974&scoped=true"
import script from "./PersonalTimetablePage.vue?vue&type=script&lang=js"
export * from "./PersonalTimetablePage.vue?vue&type=script&lang=js"

import "./PersonalTimetablePage.vue?vue&type=style&index=0&id=11bb2974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bb2974"]])

export default __exports__